import React from 'react'

const WhyNowSection = () => {
  return (
    <section className='text-center p-16'>
      <h2 className='text-5xl md:text-6xl font-bold mb-10'>Why now?</h2>
      <p className='text-xl font-light tracking-wide'>
        Due to the rapid shift of big tech companies towards cookie-less advertising and lack of highly contextual
        advertising formats, this is the right time to get into this and solve the problem.
      </p>
    </section>
  )
}

export default WhyNowSection
